// Runtime read types, not new flag definitions or provider defaults. Historical
// Boolean annotations do not describe the fee JSON or price refresh consumers.
export const legacyReadTypes: { [key: string]: 'boolean' | 'number' | 'string' | 'object' } = {
  curbsideVehicleDescriptionMaxLength: 'number',
  fireOrderAhead: 'number',
  CheckoutLimitOverrideCents: 'number',
  checkoutDeliveryMinimumOverrideCents: 'number',
  CheckoutCateringLimitOverrideCents: 'number',
  checkoutCateringMinimumOverrideCents: 'number',
  minimumAppflowBuildId: 'number',
  deliveryRadiusInMiles: 'number',
  deliveryBannerPolling: 'number',
  datadogRumSampleRate: 'number',
  resetStoreResetCartTimeout: 'number',
  tipPercentThresholdCents: 'number',
  chefUpsellItemCount: 'number',
  'discounted-delivery-threshold-cents': 'number',
  'radius-for-store-locator': 'number',
  'geolocation-timeout': 'number',
  datadogLogSampleRate: 'number',
  'loyalty-in-restaurant-status-poll-interval-ms': 'number',
  'first-data-3ds-submit-timeout': 'number',
  'order-cart-version': 'number',
  'reset-cart-timeout-hrs': 'number',
  'loyalty-link-card-reward-timeout': 'number',
  'ab-testing-home-page': 'string',
  defaultServiceModeInStore: 'string',
  'enable-offer-redemption-methods': 'string',
  'enable-test-rutw-specific-prize': 'string',
  mobileCartUpsellLocation: 'string',
  'chef-recommendation-engine-2': 'string',
  'rutw-round-start-timestamp': 'string',
  'enable-iframe-campaign-url': 'string',
  'enable-iframe-offer-url': 'string',
  'enable-iframe-offer-url-not-success': 'string',
  'enable-forced-native-app-update': 'string',
  'lieferando-button-url': 'string',
  'ubereats-button-url': 'string',
  'th-worth-the-wait-lto': 'string',
  'google-pay-allowed-payment-methods': 'string',
  'enable-account-sections-variations': 'object',
  'enable-in-restaurant-variations': 'object',
  'enable-premium-combo-slots': 'string',
  'enable-prepaid-payment-methods': 'object',
  'enable-rutw-countdown': 'object',
  'hide-items-from-nutrition-info': 'object',
  'my-account-fields-variations': 'object',
  'order-locator-tabs': 'object',
  'payment-fields-variations': 'object',
  'adyen-supported-card-brands-variations': 'object',
  'supported-card-brands-variations': 'object',
  'sign-up-fields-variations': 'object',
  'store-card-button-options': 'object',
  'timed-fire-options': 'object',
  'enable-override-country-store-restriction': 'string',
  'rutw-earning-period': 'object',
  'enable-one-time-password': 'string',
  'tiered-catering-delivery-fees': 'object',
  'tiered-delivery-fees': 'object',
  orderPriceRefreshIntervalMs: 'number',
};

// Exact FS-DEPRECATION dispositions from the pinned launchdarkly-flags.csv.
// Dynamic CMS/directive keys use this same exclusion set; spelling is irrelevant.
export const legacyExcludedKeys = new Set([
  'adobe-experimentation',
  'apple-wallet-banner-enabled',
  'apr-value-update-communication',
  'bioauth-v2',
  'canada-post-strike-communication',
  'cancel-credit-card',
  'cda-screen-before-funding',
  'crave-offer',
  'credit-approved-screen-v2',
  'credit-builder',
  'credit-limit-increase-offer',
  'credit-statement-quantity-increase',
  'customer-referrals',
  'customer-referrals-bottom-sheet',
  'customer-referrals-bottom-sheet-home',
  'customer-referrals-launch-toggle',
  'customer-referrals-new-label',
  'customer-token-with-cognito-metadata',
  'debug-screen',
  'drop-off-comm-accept-credit-agreement-email',
  'drop-off-comm-credit-selection-email',
  'drop-off-comm-select-and-submt-id-email',
  'duplicate-cash-advance-transaction-fix',
  'dynamic-air-enabled',
  'dynamic-user-info-screen',
  'enable-fs-backend-wind-down',
  'enable-fs-wind-down',
  'experiment-fs-entry-point',
  'experiment-fs-home-referral-position',
  'experiment-fs-product-selection',
  'first-purchase-offer-payout',
  'flinks-webhook-improvements',
  'fs-enabled',
  'fs-improvements-profile-creation',
  'fs-improvements-signup-flow',
  'fs-purchase-txn-rutw-bonus-roll',
  'fs-signup-rutw-bonus-rolls',
  'get-application-status-from-neo',
  'in-store-referral',
  'legal-age-validation',
  'logout-idle-user',
  'loyalty',
  'metrolinx-offer',
  'name-dob-address-combination',
  'new-ds-email-templates-enabled',
  'onboarding-refactor',
  'onfido-indigenous-status',
  'onfido-studio',
  'push-provision',
  'push-provision-android',
  're-onfido',
  'referral-reward-upgrade',
  'rounding-transaction-enabled',
  'secured-fallback-ux-enhancement',
  'show-credit-limit-increase-setting',
  'statement-balance-card-v2',
  'statement-balance-card-v3',
  'statement-balance-tile-enabled',
  'statement-credits-tile-public-launch-enabled',
  'thdfs-7519-skip-credit-check-screen-for-secured',
  'the-everyday-account-eft',
  'timbot-application',
  'updated-agreements',
  'welcome-offer-reward-upgrade',
  'welcome-offer-timshop-eligibility',
  'welcome-offer-timshop-payout',
]);

// Current literal @gateway document keys (including keys absent from inventory).
// Used only for gateway change subscriptions, never an eager catalog evaluation.
export const legacyGatewayKeys = [
  'enable-gateway-addCreditAccount',
  'enable-gateway-addGiftAccount',
  'enable-gateway-checkRefundEligibility',
  'enable-gateway-commitOrder',
  'enable-gateway-createLoginForVendor',
  'enable-gateway-createLoyaltyUser',
  'enable-gateway-createSupportCase',
  'enable-gateway-deepflame',
  'enable-gateway-deleteAccount',
  'enable-gateway-deliveryQuote',
  'enable-gateway-deliveryRestaurant',
  'enable-gateway-encryptionDetails',
  'enable-gateway-exchangeOTPCodeForCognitoCredentials',
  'enable-gateway-getPrepaidsBalance',
  'enable-gateway-getTimShopUrl',
  'enable-gateway-gifts',
  'enable-gateway-listUserCouponTokens',
  'enable-gateway-loyalty',
  'enable-gateway-me',
  'enable-gateway-order',
  'enable-gateway-pluData',
  'enable-gateway-prepaidsMerge',
  'enable-gateway-prepaidsReload',
  'enable-gateway-prepaidsTransactions',
  'enable-gateway-priceOrder',
  'enable-gateway-redeemCoupon',
  'enable-gateway-requestMyInfo',
  'enable-gateway-restaurant',
  'enable-gateway-restaurants',
  'enable-gateway-rutr',
  'enable-gateway-signUpComplete',
  'enable-gateway-uniqueStores',
  'enable-gateway-updateMe',
  'enable-gateway-updateOrder',
  'enable-gateway-userAccounts',
  'enable-gateway-userFavorites',
  'enable-gateway-userOrders',
  'enable-gateway-userRequestsRefund',
  'enable-gateway-validateAuthJwt',
];

// Exhaustive audited concrete readers, including inventory-absent keys.
// Enumeration exposes keys, but evaluations remain lazy on property access.
export const legacyKnownKeys = [
  'CheckoutCateringLimitOverrideCents',
  'CheckoutLimitOverrideCents',
  'ab-testing-home-page',
  'autoFillTestCard',
  'calories-for-options-and-modifiers-visible-web',
  'checkoutCateringMinimumOverrideCents',
  'checkoutDeliveryMinimumOverrideCents',
  'coms-prefs-consolidation',
  'curbsideVehicleDescriptionMaxLength',
  'datadogLogSampleRate',
  'datadogRumSampleRate',
  'defaultServiceModeInStore',
  'delivery',
  'deliveryBannerPolling',
  'deliveryRadiusInMiles',
  'disable-recents-and-favorites-web',
  'disableDineIn',
  'disableDriveThru',
  'disableLocalization',
  'disableTakeOut',
  'discounted-delivery-threshold-cents',
  'displayNutritionWithModifiersFromSanity',
  'enable-account-in-footer',
  'enable-account-region-verification',
  'enable-account-sections-variations',
  'enable-add-extras',
  'enable-alpha-beta-store-ordering',
  'enable-always-show-redeem-instore-button-for-rewards',
  'enable-amenities-section',
  'enable-app-rating-on-order-completed',
  'enable-beeper-modal',
  'enable-bottom-hero-button',
  'enable-calories-calculator',
  'enable-cart-modal-error-detailed-error-list',
  'enable-cash-payment',
  'enable-ccpa-do-not-sell-button',
  'enable-checkout-modal-fz-information',
  'enable-checkout-upsell-items-2',
  'enable-claim-loyalty-points',
  'enable-clear-store-after-order',
  'enable-closing-time-dialog',
  'enable-cognitoid-qr-code',
  'enable-consolidated-delivery-restaurant-backend-logic',
  'enable-cooldown-toast-info',
  'enable-customer-can-edit-own-phone-number',
  'enable-delivery-checkout-outside-opening-hours',
  'enable-delivery-details-form-require-address-2',
  'enable-delivery-only',
  'enable-delivery-order-timed-fire',
  'enable-desktop-side-navigation',
  'enable-digital-wallet-migration',
  'enable-discounts-on-order-receipt',
  'enable-duplicate-card-vault-error-modal',
  'enable-edit-cart',
  'enable-favorites',
  'enable-favorites-display-calories',
  'enable-feature-nutrition-integration',
  'enable-feature-onboarding',
  'enable-fees-on-order-receipt',
  'enable-find-restaurant-link',
  'enable-fixed-add-to-order-and-quantity-button',
  'enable-footer-cart-page',
  'enable-forced-native-app-update',
  'enable-forter-fraud',
  'enable-fulfillment-service-commit-order',
  'enable-fulfillment-service-get-order',
  'enable-fulfillment-service-get-user-orders',
  'enable-gateway-addCreditAccount',
  'enable-gateway-addGiftAccount',
  'enable-gateway-checkRefundEligibility',
  'enable-gateway-commitOrder',
  'enable-gateway-createLoginForVendor',
  'enable-gateway-createLoyaltyUser',
  'enable-gateway-createSupportCase',
  'enable-gateway-deepflame',
  'enable-gateway-deleteAccount',
  'enable-gateway-deliveryQuote',
  'enable-gateway-deliveryRestaurant',
  'enable-gateway-encryptionDetails',
  'enable-gateway-exchangeOTPCodeForCognitoCredentials',
  'enable-gateway-getPrepaidsBalance',
  'enable-gateway-getTimShopUrl',
  'enable-gateway-gifts',
  'enable-gateway-listUserCouponTokens',
  'enable-gateway-loyalty',
  'enable-gateway-me',
  'enable-gateway-order',
  'enable-gateway-pluData',
  'enable-gateway-prepaidsMerge',
  'enable-gateway-prepaidsReload',
  'enable-gateway-prepaidsTransactions',
  'enable-gateway-priceOrder',
  'enable-gateway-redeemCoupon',
  'enable-gateway-requestMyInfo',
  'enable-gateway-restaurant',
  'enable-gateway-restaurants',
  'enable-gateway-rutr',
  'enable-gateway-signUpComplete',
  'enable-gateway-uniqueStores',
  'enable-gateway-updateMe',
  'enable-gateway-updateOrder',
  'enable-gateway-userAccounts',
  'enable-gateway-userFavorites',
  'enable-gateway-userOrders',
  'enable-gateway-userRequestsRefund',
  'enable-gateway-validateAuthJwt',
  'enable-hamburger-menu-on-mobile',
  'enable-hide-modifier-multipliers',
  'enable-hide-store-modal-order-here-button',
  'enable-hide-subtotal-line',
  'enable-hide-tax-line',
  'enable-iap-prefetching',
  'enable-in-restaurant-variations',
  'enable-link-physical-card',
  'enable-locator-clear-store-and-sm-button',
  'enable-locator-ui-refresh',
  'enable-loyalty-points-in-header',
  'enable-loyalty-qr-and-short-code',
  'enable-loyalty-redeem-in-restaurant-screen-in-all-stores',
  'enable-loyalty-tags-store-locator',
  'enable-main-fab-button',
  'enable-menu-list-ui',
  'enable-menu-service-data',
  'enable-menu-upsell-items',
  'enable-move-signup-after-cart',
  'enable-my-code-new-ui',
  'enable-my-code-payment-method',
  'enable-my-code-ui-v3',
  'enable-native-mobile-account',
  'enable-new-giftCardLoad-mutation-on-web',
  'enable-new-menu-customization-design',
  'enable-numeric-phone-validation',
  'enable-nutrition-explorer-allergens',
  'enable-offer-gifting',
  'enable-offer-qr-code',
  'enable-offer-redemption-methods',
  'enable-offers-edit-cart',
  'enable-offers-static-page',
  'enable-one-time-password',
  'enable-order-number-generation',
  'enable-order-ready-locker-code-modal',
  'enable-override-country-store-restriction',
  'enable-override-delivery-time',
  'enable-payback',
  'enable-payment-error-continue',
  'enable-pin-validation-feature',
  'enable-plk-transparent-background-menu-tile',
  'enable-plu-offer-qr-code',
  'enable-premium-combo-slots',
  'enable-prepaid-digital-card-creation',
  'enable-prepaid-payment-methods',
  'enable-price-and-calories-in-menu',
  'enable-product-image-disclaimer',
  'enable-product-ingredients',
  'enable-qr-code-in-my-code-page',
  'enable-qr-snap',
  'enable-query-vr-payment-merchant-id',
  'enable-recent-items-add-to-cart',
  'enable-recent-items-in-menu',
  'enable-reorder',
  'enable-rewards-static-page',
  'enable-rpos-order-timed-fire',
  'enable-show-address2-before-city',
  'enable-show-picker-aspects-in-static-menu',
  'enable-side-by-side-hero-buttons',
  'enable-signout-on-invalid-token',
  'enable-signup-cart-button-text',
  'enable-signup-communications-preselection',
  'enable-skip-refetch-recent-orders-on-commit',
  'enable-sort-offers-for-service-mode',
  'enable-static-menu-allergens',
  'enable-store-selection-2',
  'enable-street-number-after-street-name',
  'enable-tabbed-menu-bar',
  'enable-tabbed-menu-bar-recents',
  'enable-table-service',
  'enable-terms-link-on-checkout',
  'enable-test-apple-pay-web',
  'enable-test-google-pay-web',
  'enable-th-hockey-challenge',
  'enable-th-loyalty-barcode-copy-to-clipboard',
  'enable-th-loyalty-onboarding-refresh',
  'enable-th-loyalty-redirect',
  'enable-th-media-services',
  'enable-th-offer-tags',
  'enable-th-offers-page',
  'enable-th-reward-tier-toggle-ui',
  'enable-th-round-up',
  'enable-th-scan-and-pay',
  'enable-th-timbits-lto',
  'enable-third-party-redirect-unavailable-delivery-modal',
  'enable-tim-shop-auth',
  'enable-timed-fire-for-drive-thru-web',
  'enable-two-step-sign-up',
  'enable-unverified-loyalty-registration',
  'enable-unverified-saved-payments',
  'enable-user-not-found-mask-on-auth-flows',
  'enable-web-catering',
  'enable-zero-bounce-error-modal',
  'enableAccountDeleteOneTrust',
  'enableAllergensDisclaimer',
  'enableAutoLocale',
  'enableAutoSelectRestaurant',
  'enableAutoSignInOnSignUp',
  'enableBottomServiceMode',
  'enableCatering',
  'enableCateringDelivery',
  'enableCognitoSignupInBe',
  'enableCommunicationPreferences',
  'enableCookieVersioning',
  'enableCurbside',
  'enableCustomBirthdayInput',
  'enableDeliveryCancellationPolicy',
  'enableDeliveryWatchDriverLocation',
  'enableDiagnosticTools',
  'enableDoubleVaultingFromPaymentMethods',
  'enableFavoriteStores',
  'enableFormattedCaloriesForDefault',
  'enableFreeDeliveryCheckoutProgressBar',
  'enableHideOffersForServiceMode',
  'enableHomePageRecentItems',
  'enableImCloseDisplay',
  'enableInternalDiagnosticTools',
  'enableLockedOffers',
  'enableMoreInfoOptionalOfferDisclaimer',
  'enableNewPhoneNumberField',
  'enableNewServiceModeFlow',
  'enableNutritionDecimals',
  'enableNutritionExplorer',
  'enableOfferBadges',
  'enableOffers',
  'enableOffersSelectRestaurantCta',
  'enableOldOffersHomepageSection',
  'enableOrderLinkNav',
  'enableOrderTimedFire',
  'enableOrderTimedFireCarrols',
  'enableOrderTimedFireNCR',
  'enableOrderTimedFireQST',
  'enableOrderTimedFireSICOM',
  'enableOrdering',
  'enablePromoCodeAtCheckout',
  'enablePromoCodeOffers',
  'enableRecentItemsWithModifiers',
  'enableRequestMyInformation',
  'enableRutr',
  'enableRutrHomePageBanner',
  'enableSanityCdn',
  'enableSanityControlledMobileNav',
  'enableSanityFooter',
  'enableSanityWebNavigation',
  'enableServiceModeCartSelection',
  'enableSignUp',
  'enableStaticMenu',
  'enableStoreConfirmationModal',
  'enableThDirectPayApplePay',
  'enableThDirectPayGooglePay',
  'enableThVoucherCodes',
  'enableUserSavedDeliveryAddressPhone',
  'exp-unified-auth-entry-web',
  'fireOrderAhead',
  'fiserv-reduction',
  'force-homepage-auth',
  'force-restaurant-selection-for-rewards',
  'gift-card-payment-method',
  'hide-items-from-nutrition-info',
  'hide-tip-amount-checkout',
  'hide-ui-calories',
  'hideServiceMode',
  'lieferando-button-url',
  'mobileCartUpsellLocation',
  'my-account-fields-variations',
  'new-wizard-issue-collector',
  'nutritionEuDisplay',
  'order-cart-version',
  'order-locator-tabs',
  'orderPriceRefreshIntervalMs',
  'payment-fields-variations',
  'radius-for-store-locator',
  'reset-cart-timeout-hrs',
  'resetStoreResetCartTimeout',
  'restaurants-force-closed',
  'send-postal-code-only-for-first-data-payment',
  'send-same-otp-code-once',
  'show-increased-delivery-fees-modal',
  'show-loyalty-banner-v2-in-home',
  'show-ordering-issue-info',
  'show-price-instead-free-in-cart',
  'show-store-service-modes',
  'sign-up-fields-variations',
  'singleRegionLanguageSelector',
  'skip-loyalty-store-validation',
  'store-card-button-options',
  'supported-card-brands-variations',
  'temp-enable-footer-component-update',
  'th-direct-pay',
  'th-worth-the-wait-lto',
  'tiered-catering-delivery-fees',
  'tiered-delivery-fees',
  'timed-fire-options',
  'tipPercentThresholdCents',
  'ubereats-button-url',
  'use-high-volume-support-msg',
];
